module.exports = __webpack_public_path__ + "media/images/plans/ceremony/estimate_1-0bcfe4f28dcc9f7e382edd272f5fc69e.jpg";